<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{
  artworkName?: string;
  artworkId?: number;
}>();

const emit = defineEmits<{
  (event: "submitted", status: boolean): void;
}>();

const sendingMessage = ref(false);

const form = ref<ContactForm>({
  name: "",
  email: "",
  phone: "",
  subject: props.artworkName ? `Inquiry about ${props.artworkName} - ${props.artworkId}` : "",
  message: "",
});

const disabledSubject = computed(() => {
  return props.artworkName != undefined && props.artworkId != undefined;
});

const messageSent = ref(false);
const response = ref({
  message: "",
  status: true,
});

const handleSubmit = async (payload: SubmitEvent) => {
  sendingMessage.value = true;
  const data = await $fetch("/api/contact-me", {
    method: "POST",
    body: form.value,
  });
  response.value.message = data.message ?? "";
  response.value.status = data.status == "success" ? true : false;
  if (response.value.status) {
    form.value = {
      name: "",
      email: "",
      phone: "",
      subject: props.artworkName ? `Inquiry about ${props.artworkName} - ${props.artworkId}` : "",
      message: "",
    };
  }
  sendingMessage.value = false;
  messageSent.value = true;
  emit("submitted", response.value.status);
  setTimeout(() => {
    messageSent.value = false;
  }, 3000);
};
</script>
<template>
  <form @submit.prevent="handleSubmit($event)" id="xboot-contact-form" name="xboot_message_form" class="contcat-form" style="margin: 0; padding-bottom: 20px;">
    <div class="form-head">
      <div class="single-input">
        <input type="text" name="name" placeholder="Name" required v-model="form.name" />
      </div>
      <div class="single-input">
        <input type="email" name="email" placeholder="Email" required v-model="form.email" />
      </div>
    </div>
    <div class="form-head">
      <div class="single-input">
        <input type="tel" placeholder="123-456-7890" required name="phone" v-model="form.phone" />
      </div>
      <div class="single-input">
        <input type="text" name="subject" placeholder="Subject" required v-model="form.subject" :disabled="disabledSubject" />
      </div>
    </div>
    <div class="form-body">
      <textarea name="message" class="text-area" cols="30" rows="10" placeholder="Message" required v-model="form.message"></textarea>
    </div>
    <div style="display: flex; flex-direction: column; position: relative">
      <button class="button-boxed" type="submit" value="submit">{{ sendingMessage ? "Sending..." : "Send message" }} <i v-if="!sendingMessage" class="ti-arrow-right"></i></button>
      <div
        class="response-alert alert alert-success fade"
        :class="{
          in: messageSent,
          'alert-success': response.status,
          'alert-danger': !response.status,
        }"
        role="alert"
      >
        <strong>{{ response.status ? "Thanks!" : "Error!" }}</strong> <span>{{ response.message }} </span>
      </div>
    </div>
  </form>
</template>
<style scoped>
.response-alert {
  width: 100%;
  position: fixed;
  top: 1.5rem;
  left: 50%;
  height: 80px;
  z-index: 9999;
  max-width: 400px;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: larger;
  gap: 1rem;
}
</style>
